import { render } from "./FinalRegister.vue?vue&type=template&id=06e32ec0&scoped=true"
import script from "./FinalRegister.vue?vue&type=script&lang=js"
export * from "./FinalRegister.vue?vue&type=script&lang=js"

import "./FinalRegister.vue?vue&type=style&index=0&id=06e32ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06e32ec0"]])

export default __exports__